import {computed, inject, Injectable, Signal} from '@angular/core';
import {TagsStore} from '../stores/tags.store';

@Injectable({providedIn: 'root'})
export class TagsContext {
	private readonly store = inject(TagsStore);

	readonly allTags = this.store.tags;
	readonly loading = this.store.loading;
	readonly error = this.store.error;

	readonly tags = computed(() =>
		this.allTags().filter(
			t => t.active
		)
	)

	tagById(id: Signal<string | null>) {
		return computed(() => {
			const tagId = id();
			if (!tagId) return null;

			return this.allTags().find(t => t.id === tagId) ?? null;
		});
	}

	getTagSnapshotById(id: string) {
		return this.allTags().find(t => t.id === id) ?? null;
	}
}
